<template lang="pug">
.ResultCalendar
  .header
    .prev(
      v-menuHoverSound
      v-menuClickSound
      @click="handlePrevClick"
    ) ＜
    .title {{year}}年{{month}}月の練習結果
    .next(
      v-menuHoverSound
      v-menuClickSound
      @click="handleNextClick"
    ) ＞
  .body(:class="`is-padding-${this.firstDayPadding}`")
    .date(
      v-for="i in endOfMonthDay"
      :class="{ 'is-done': isCompleted(i), 'is-today': isToday(i) }"
    )
      .inner
        .label {{i}}
        .check()
          font-awesome-icon.icon(icon="thumbs-up")

</template>

<script>
import moment from 'moment'
// import * as _ from 'lodash'

export default {
  name: 'km-result-calendar',
  components: {},
  props: {
    dates: {
      default: () => []
    }
  },
  data() {
    return {
      year: moment().year(),
      month: moment().month() + 1,
      endOfMonthDay: moment().endOf('month').date(),
      firstDayPadding: moment().startOf('month').day(),
      sampleDates: []
    }
  },
  computed: {},
  methods: {
    isToday(day) {
      const targetDate = `${this.year}-${String(this.month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      return targetDate === moment().format('YYYY-MM-DD')
    },
    isCompleted(day) {
      const targetDate = `${this.year}-${String(this.month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      return this.dates.findIndex(date => date === targetDate) !== -1
    },
    changeMonth(type) {
      const currentDate = moment(`${this.year}-${this.month}-01`, 'YYYY-M-DD')
      const newDate = type === 'prev' ? currentDate.subtract(1, 'months') : currentDate.add(1, 'months');
      this.year = newDate.year()
      this.month = newDate.month() + 1
      this.endOfMonthDay = newDate.endOf('month').date()
      this.firstDayPadding = newDate.startOf('month').day()
    },
    handlePrevClick() {
      this.changeMonth('prev')
    },
    handleNextClick() {
      this.changeMonth('next')
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.ResultCalendar {
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  border-bottom: 3px solid #ccc;

  .title {
    flex: 1;
    padding: 10px;
    text-align: center;
    font-size: 2.5rem;
  }

  .prev,
  .next {
    display: flex;
    justify-content: center;;
    align-items: center;
    margin: 0 15px;
    width: 50px;
    height: 50px;
    border: 2px solid #000;
    border-radius: 10px;

    &:hover {
      transform: scale(1.1);
    }
  }
}

.body {
  display: grid;
  margin: 15px;
  height: 100%;
  border-top: 3px solid #ccc;
  border-left: 3px solid #ccc;
  background: #ccc;
  grid-template-rows: repeat(6, auto);
  grid-template-columns: repeat(7, 1fr);

  &.is-padding-0 .date:first-child { grid-column-start: 0; }
  &.is-padding-1 .date:first-child { grid-column-start: 1; }
  &.is-padding-2 .date:first-child { grid-column-start: 2; }
  &.is-padding-3 .date:first-child { grid-column-start: 3; }
  &.is-padding-4 .date:first-child { grid-column-start: 4; }
  &.is-padding-5 .date:first-child { grid-column-start: 5; }
  &.is-padding-6 .date:first-child { grid-column-start: 6; }


  .date {
    position: relative;
    padding: 2px 10px;
    height: 60px;
    border-right: 3px solid #ccc;
    border-bottom: 3px solid #ccc;
    background: #fff;
    font-size: 2rem;
    color: #000;
  }

  .date.is-today {
    padding: 0;
    .inner {
      padding: 2px 10px;
      height: 57px;
      border: 3px solid red;
    }
  }

  .date.is-done {
    background: rgb(255, 245, 227);
    .label {
      color: orange;
      font-weight: bold;
    }
    .check {
      display: block;
    }
  }

  .label {
    color: #aaa;
  }

  .check {
    display: none;
    position: absolute;
    right: 10px;
    bottom: 10px;

    .icon {
      color: orange;
      font-size:3rem;
      line-height: 1;
    }

  }
}

</style>
